export const SOFTLINE_API_ROHSTOFFBILANZ_QUERY = '/v1/rohstoffbilanz/v1/molkerei/rohstoffbilanz/query';
export const SOFTLINE_API_ROHSTOFFBILANZ_QUERY_DETAIL = '/v1/rohstoffbilanz/v1/molkerei/rohstoffbilanz/detail';

